import {type NavigationGuardNext, type RouteLocationNormalized} from "vue-router";
import {PublicNs} from "@shared/types/public.namespace";
import {publicPageAuthGuard} from "@domains/publish/project/resolvers/public-page-authentation.guard.ts";
import {estimationPageAuthGuard} from "@domains/publish/estimation/resolvers/estimation-page-authentation.guard.ts";

export const publishRoutes = [
  {
    path: '/publish/:projectId/:token',
    name: PublicNs.PublicRouteEnums.EDITOR,
    component: () => import('@domains/publish/layout/public-layout.vue'),
    redirect: {name: PublicNs.PublicRouteEnums.FEATURE},
    props: true,
    meta: {
      requiresAuth: false
    },
    beforeEnter: [
      (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
        publicPageAuthGuard(to, from, next);
      }
    ],
    children: [
      {
        path: 'feature',
        name: PublicNs.PublicRouteEnums.FEATURE,
        component: () => import('@domains/publish/project/view/feature/feature-view.vue'),
        props: true
      },
      {
        path: 'feature/:featureId',
        name: PublicNs.PublicRouteEnums.FEATURE_SELECTED,
        component: () => import('@domains/publish/project/view/feature/feature-view.vue'),
        props: true
      },
      {
        path: 'feature/page/:pageId',
        name: PublicNs.PublicRouteEnums.PAGE_SELECTED,
        component: () => import('@domains/publish/project/view/feature/feature-view.vue'),
        props: true
      },
      {
        path: 'screen',
        name: PublicNs.PublicRouteEnums.SCREEN,
        component: () => import('@domains/publish/project/view/screen/screen-view.vue'),
        props: true
      },
      {
        path: 'screen/:screenId',
        name: PublicNs.PublicRouteEnums.SCREEN_SELECTED,
        component: () => import('@domains/publish/project/view/screen/screen-view.vue'),
        props: true
      }
    ]
  },
  {
    path: '/publish/estimation/:projectId/:token',
    name: PublicNs.PublicRouteEnums.ESTIMATION,
    component: () => import('@domains/publish/layout/public-layout.vue'),
    props: true,
    meta: {
      requiresAuth: false
    },
    beforeEnter: [
      (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
        estimationPageAuthGuard(to, from, next);
      }
    ],
    children: [
      {
        path: '',
        name: PublicNs.PublicRouteEnums.ESTIMATION_FEATURE,
        component: () => import('@domains/publish/estimation/view/estimation-view.vue'),
        props: true
      }
    ]
  },

  {
    path: '/publish/error',
    name: PublicNs.PublicRouteEnums.ERROR,
    component: () => import('@domains/publish/layout/error-view.vue'),
    props: true,
    meta: {
      requiresAuth: false
    }
  }
];
